import React from 'react'

import Branding from 'shared/branding'

const BrandLogo = ({ invertedLogo }) => {
  const { logoImage, invertedLogo: brandInvertedLogo, name } = Branding.current
  const alt = `${name} logo`

  const logo = (invertedLogo && brandInvertedLogo) || logoImage

  return (
    <img
      src={logo}
      data-test="images.company-logo"
      alt={alt}
      className="branded-account-header"
    />
  )
}

BrandLogo.displayName = 'BrandLogo'

export default BrandLogo
